// extracted by mini-css-extract-plugin
export default {"header":"PaymentInfo_header__+Y8Uh","peekContainer":"PaymentInfo_peekContainer__itC4K","paymentDetails":"PaymentInfo_paymentDetails__mpmb6"};